export const HOME = {
  heroTitle: 'home-hero-title',
  heroBookingBtn: 'home-hero-booking-btn',
  heroTrackBtn: 'home-hero-track-btn',
  bookingBrand: 'home-booking-brand',
  bookingModel: 'home-booking-model',
  bookingSize: 'home-booking-size',
  bookingIssue: 'home-booking-issue',
  bookingDesc: 'home-booking-desc',
  bookingServiceType: 'home-booking-service-type',
  bookingName: 'home-booking-name',
  bookingEmail: 'home-booking-email',
  bookingPhone: 'home-booking-phone',
  bookingDate: 'home-booking-date',
  bookingSubmitBtn: 'home-booking-submit-btn',
  trackingInput: 'home-tracking-input',
  trackingSubmitBtn: 'home-tracking-submit-btn',
  trackingErrorMsg: 'home-tracking-error-msg',
};

export const DASHBOARD = {
  container: 'dashboard-container',
  jobId: 'dashboard-job-id',
  statusBadge: 'dashboard-status-badge',
  clientName: 'dashboard-client-name',
  deviceDetails: 'dashboard-device-details',
  costEstimate: 'dashboard-cost-estimate',
  paymentStatus: 'dashboard-payment-status',
  payButton: 'dashboard-pay-button',
  cardNumInput: 'dashboard-card-number-input',
  cardHolderInput: 'dashboard-cardholder-name-input',
  cardExpiryInput: 'dashboard-expiry-input',
  cardCvvInput: 'dashboard-cvv-input',
  cardSubmitBtn: 'dashboard-card-submit-button',
  paymentSuccessMsg: 'dashboard-payment-success-msg',
  ticketSubject: 'dashboard-ticket-subject',
  ticketMessage: 'dashboard-ticket-message',
  ticketSubmitBtn: 'dashboard-ticket-submit-button',
  ticketSuccessMsg: 'dashboard-ticket-success-msg',
  notificationTabBtn: 'dashboard-notification-tab-btn',
  notificationList: 'dashboard-notification-list',
  adminTabBtn: 'dashboard-admin-tab-btn',
  adminStatusSelect: 'dashboard-admin-status-select',
  adminMessageInput: 'dashboard-admin-message-input',
  adminUpdateBtn: 'dashboard-admin-update-button',
  reviewClientInput: 'dashboard-review-client-input',
  reviewTvModelInput: 'dashboard-review-tv-model-input',
  reviewRatingSelect: 'dashboard-review-rating-select',
  reviewCommentInput: 'dashboard-review-comment-input',
  reviewSubmitBtn: 'dashboard-review-submit-button',
};
